import * as routes from 'app/routes';

const carrierToRoutes = {
  sprint: {
    insuranceRoute: routes.sprintInsurance,
    insuranceConfirmRoute: routes.sprintInsuranceConfirm,
    addInsuranceRoute: routes.sprintInsuranceDevice,
  },
  bypassed: {
    insuranceRoute: routes.bypassedInsurance,
    insuranceConfirmRoute: routes.bypassedInsuranceConfirm,
    addInsuranceRoute: routes.bypassedInsuranceDevice,
  },
  quick: {
    insuranceRoute: routes.quickInsurance,
    insuranceConfirmRoute: routes.quickInsuranceConfirm,
    addInsuranceRoute: routes.quickInsuranceDevice,
  }
}

const getCarrier = ({ sprintSubId, bypassedSubId, quickSubId }) => {
  let carrier = '';

  if (sprintSubId) {
    return 'sprint';
  } else if (bypassedSubId) {
    return 'bypassed';
  } else if (quickSubId) {
    return 'quick';
  }

  return carrier
}

export const generateLinksList = ({ contracts, sprintSubId, bypassedSubId, quickSubId, purchases, devices }) => {
  let links = [];

  const subId = sprintSubId || bypassedSubId || quickSubId;
  const subRoutes = carrierToRoutes[getCarrier({ sprintSubId, bypassedSubId, quickSubId })];

  const hasActiveContract = contracts.find(contract => contract.status === 'active');
  const pendingContract = contracts.find(contract => contract.status === 'pending');
  const pendingDevice = devices && devices.find(device => device.status === 'pending');

  if (hasActiveContract) {
    const insuranceRoute = subRoutes.insuranceRoute(subId);
    
    links.push({ 
      to: insuranceRoute,
      type: 'general',
      text: 'Device Protection Information',
    });
  }

  if (pendingContract && purchases && purchases.length) {
    const insurancePurchaseRoute = routes.insurancePurchase(purchases[0].id, pendingContract.id);

    links.push({ 
      to: insurancePurchaseRoute,
      type: 'insurancePurchase',
      text: '',
    });
  }
  else if (pendingContract && pendingDevice) {
    const { device_specs: sku, plan: insPlanId } = pendingDevice;
    const insuranceConfirmRoute = subRoutes.insuranceConfirmRoute(subId, sku, insPlanId);

    links.push({ 
      to: insuranceConfirmRoute,
      type: 'general',
      text: 'Resume Adding Device Protection',
    });
  }
  else if (!hasActiveContract) {
    const addInsuranceRoute = subRoutes.addInsuranceRoute(subId);

    links.push({ 
      to: addInsuranceRoute,
      type: 'general',
      text: 'Add Device Protection',
    });
  }

  return links;

}